export const HOME_CONTENT_TYPE_KEYS = {
  BANNER: 'home.banner',
  MODULE_CARDS: 'home.module_cards',
  INFO_CARDS: 'search.info_cards',
};

export const resolveHomeLang = (i18nLang) => {
  const raw = String(i18nLang || 'es').toLowerCase();
  if (raw.startsWith('en')) return 'en';
  return 'es';
};

export const pickHomeItems = (items, typeKey, lang) => {
  const ofType = (items || []).filter((row) => row.type_key === typeKey && row.enabled !== false);
  const wanted = resolveHomeLang(lang);
  const byLang = ofType.filter((row) => row.lang === wanted);
  const source = byLang.length ? byLang : ofType.filter((row) => row.lang === 'es');
  return [...source].sort((a, b) => (a.sort || 0) - (b.sort || 0) || (a.id || 0) - (b.id || 0));
};
